export default __webpack_public_path__ + "static/media/complementary--bicycles-turn-right--g1.b50cdd8a.png";